import { Injectable } from '@angular/core';

declare global {
  interface Window {
    LemonLearningReady: (player: any) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LemonLearningService {

  initializeLemonLearning(userName: string, userEmail: string, userCountry: string, role: string) {
    console.log('🍋 Initializing Lemon Learning for:', userEmail);
    // Dispatch l'événement custom pour déclencher Lemon Learning
    globalThis.document.dispatchEvent(new CustomEvent('LEMONLEARNING_HOST_READY', {
      detail: {
        name: userName,
        email: userEmail,
        country: userCountry,
        role: role
      }
    }));
  }
}